import MeditatedGospel from "../../../api/meditated-gospel/content";
import DatePicker from "../../../components/date-picker";
import FontControllers from "../../../components/font-controllers";

export default class EvangelhoMeditado {
	constructor() {
		this.handleContent();
		this.handleDataPicker();
		this.handleFontControllers();
		this.getGospelContent();
	}

	handleContent() {
		const calendar = document.querySelector('#evangelho-meditado .calendar input');

		calendar.addEventListener('change', () =>  {
			this.getGospelContent();
		});

	}

	getGospelContent() {
		const calendar = document.querySelector('#evangelho-meditado .calendar input');

		if (calendar && calendar.value) {
			let date = this.getSelectedDate(calendar.value, '-');

			const api = new MeditatedGospel;
			this.setLoader();

			api.getMeditatedGospel(date)
			.then((data) => {
				if (data.body && data.body.posts[0]) {
					const post = data.body.posts[0];
					this.addContent(post);
					this.addTitle(post);
					this.addTumbnail(post);
				} else {
					date = this.getSelectedDate(calendar.value, '/');
					this.setNotFoundedContent(date);
				}

				this.clearLoader();
			});
		}
	}

	setNotFoundedContent(date) {
		const message = {
			content: `<strong>Nenhum resultado encontrado para o dia ${date}</strong>.`
		};

		this.addContent(message);
	}

	setLoader() {
		const calendar = document.querySelector('#evangelho-meditado .content');
		calendar.classList.add('deactive');

		const loader = document.querySelector('#evangelho-meditado .loader');
		loader.classList.remove('deactive');
	}

	clearLoader() {
		const calendar = document.querySelector('#evangelho-meditado .content');
		calendar.classList.remove('deactive');

		const loader = document.querySelector('#evangelho-meditado .loader');
		loader.classList.add('deactive');
	}

	addContent(post) {
		const content = document.querySelector('#evangelho-meditado .content-display .post-content');
		if (content) {
			content.innerHTML = this.cleanDOMStyles(post.content);
		}
	}

	cleanDOMStyles(content) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(content, 'text/html');

		const elementsWithStyle = doc.querySelectorAll('[style]');
		elementsWithStyle.forEach(element => element.removeAttribute('style'));

		return doc.body.innerHTML;
	}

	addTitle(post) {
		const title = document.querySelector('#evangelho-meditado .content-title .title-content');
		if (title && post.title) {
			title.innerHTML = post.title;
			this.setTitleDay();
			title.classList.remove('deactive');
		} else {
			title.classList.add('deactive');
		}
	}

	addTumbnail(post) {
		const thumbnailContainer = document.querySelector('#evangelho-meditado .content-display .post-media .thumbnail');
		const thumbnail = document.querySelector('#evangelho-meditado .content-display .post-media .thumbnail > img');

		if (post.thumbnail && thumbnail) {
			thumbnail.setAttribute('src', post.title);
			thumbnailContainer.classList.remove('deactive');
		} else {
			thumbnailContainer.classList.add('deactive');
		}
	}

	setTitleDay() {
		const calendar = document.querySelector('#evangelho-meditado .calendar input');

		const [year, month, day] = calendar.value.split('-').map(Number);
		const date = new Date(year, month - 1, day, 12, 0, 0);

		const weekday = this.datapicker.getWeekDay(date);

		const titleDay = document.querySelector('#evangelho-meditado .content-title .title-week-day');

		if (titleDay) {
			titleDay.innerText = weekday;
		}
	}


	getSelectedDate(date, separator = '-') {

		let [year, month, day] = date.split('-').map(Number);

		day = String(day).padStart(2, '0');
		month = String(month).padStart(2, '0');

		return `${day}${separator}${month}${separator}${year}`;
	}

	handleDataPicker() {
		const calendar = document.querySelector('#evangelho-meditado .calendar');

		if (calendar) {
			this.datapicker = new DatePicker(calendar);
		}
	}

	handleFontControllers() {
		const increaseButton = document.querySelector('#evangelho-meditado .font-controllers > .plus');
		const decreaseButton = document.querySelector('#evangelho-meditado .font-controllers > .minor');
		const content = document.querySelector('#evangelho-meditado .content-display > .post-content');

		this.fontControllers = new FontControllers(content, increaseButton, decreaseButton);
	}
}
